import React, { useState, useEffect } from 'react';
import { get, map, filter, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTestAnswerKey } from '../../../../actions/performanceAnalysisActions';
import { getDateWithDay } from '../../../../api/dateFormat';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import SubjectTable from './components/SubjectTable';
import PropTypes from 'prop-types';
import './styles.scss';
import { Skeleton } from '@material-ui/lab';

export default function AnswerKeyAndResponse(props) {
  // State
  const [anchorEl, setAnchorEl] = useState(null);
  const [marksScored, setMarksScored] = useState(0);
  const [marksLost, setMarksLost] = useState(0);
  const [marksNotAttempted, setMarksNotAttempted] = useState(0);
  // const [correct, setCorrect] = useState(0);
  // const [partialCorrect, setPartialCorrect] = useState(0);
  // const [notAttempted, setNotAttempted] = useState(0);
  const [, setIncorrect] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [subjectsData, setSubjectData] = useState([]);
  const [actualScore, setActualScore] = useState(0);
  const [paperObj, setPaperObj] = useState({
    key: 'paper1',
    value: 'Paper- 01',
  });

  // Redux
  const dispatch = useDispatch();
  const jwtToken = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', '')
  );
  const TestAnswerKey = useSelector((state) =>
    get(state, 'performanceAnalysisReducer.testAnalysis', {})
  );

  useEffect(() => {
    setIsFetching(true);
    fetchTestAnswerKey(jwtToken, props.testID, dispatch).then(() => {
      setIsFetching(false);
      checkForWhichPaperDataExists();
    });
    checkForWhichPaperDataExists();
  }, []);

  //   const onRefresh = React.useCallback(() => {
  //     setIsFetching(true);
  //     fetchTestAnswerKey(jwtToken, route.params.testID, dispatch).then(() =>
  //       setIsFetching(false),
  //     );
  //   }, [isFetching]);

  useEffect(() => {
    if (TestAnswerKey) {
      let list = '';
      if (paperObj.key == 'paper1') {
        list = 'paper1.listSubject';
      } else {
        list = 'paper2.listSubject';
      }
      let listSubjects = get(TestAnswerKey, list, []);
      setSubjectData(listSubjects);
      let totalMarks = 0,
        lostMarks = 0,
        notAttemptedMarks = 0,
        correctMarks = 0,
        partialCorrectMarks = 0,
        notAttemptedper = 0,
        incorrectMarks = 0,
        totalNoQuestions = 0,
        actualScore = 0;
      map(listSubjects, function (subject) {
        if (subject && subject.listQuestion) {
          filter(subject.listQuestion, function (question) {
            actualScore = actualScore + question.ActualScore;
            if (question.Score < 0) {
              lostMarks = lostMarks - question.Score;
            } else if (question.Score > 0) {
              totalMarks = totalMarks + question.Score;
            } else if (question.Score === 0 && question.QuestionStatus === 0) {
              notAttemptedMarks = notAttemptedMarks + 1;
            }
          });
        }
        if (subject.graphStats) {
          correctMarks = correctMarks + subject.graphStats.correctQuestion || 0;
          partialCorrectMarks =
            partialCorrectMarks + subject.graphStats.partialCorrectQuestion || 0;
          notAttemptedper =
            notAttemptedper + subject.graphStats.notAttemptQuestion|| 0;
          incorrectMarks =
            incorrectMarks + subject.graphStats.inCorrectQuestion || 0 ;
          totalNoQuestions =
            totalNoQuestions + subject.graphStats.totalQuestion || 0;
            
        }
      });
      setMarksScored(totalMarks);
      setMarksLost(lostMarks);
      setMarksNotAttempted(notAttemptedMarks);
      // setCorrect(correctMarks);
      //setPartialCorrect(partialCorrectMarks);
      // setNotAttempted(notAttemptedper);
      setIncorrect(incorrectMarks);
      setTotalQuestions(totalNoQuestions);
      setActualScore(actualScore);
    }
  }, [TestAnswerKey, paperObj.key]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (key, val) => {
    setAnchorEl(null);
    if (val !== 'backdropClick') {
      setPaperObj({
        key: key,
        value: val,
      });
    }
  };

  // let formatDate = () => {
  //     if (
  //         TestAnswerKey &&
  //         TestAnswerKey.paper1 &&
  //         TestAnswerKey.paper1.TestDate
  //     ) {
  //         const months = [
  //             'JAN',
  //             'FEB',
  //             'MAR',
  //             'APR',
  //             'MAY',
  //             'JUN',
  //             'JUL',
  //             'AUG',
  //             'SEP',
  //             'OCT',
  //             'NOV',
  //             'DEC',
  //         ];
  //         let current_datetime = new Date(TestAnswerKey.paper1.TestDate);
  //         let formatted_date =
  //             current_datetime.getDate() +
  //             ' ' +
  //             months[current_datetime.getMonth()] +
  //             ' ' +
  //             current_datetime.getFullYear();
  //         return '/ ' + formatted_date;
  //     }
  //     return '';
  // };
  // Subject Card Component
  //   const SubjectCardComponent = props => (
  //     <View style={[styles.subjectView, { width: width / props.items }]}>
  //       <Text style={styles.subjectTitle}>{props.Title}</Text>
  //       {props.actualScore ? (
  //         <Text style={styles.subjectText}>
  //           {props.Details}/{props.actualScore}
  //         </Text>
  //       ) : (
  //         <Text style={styles.subjectText}>{props.Details}</Text>
  //       )}
  //     </View>
  //   );
  const checkForWhichPaperDataExists = () => {
    if (
      !isEmpty(get(TestAnswerKey, 'paper1.listSubject', [])) ||
      !isEmpty(get(TestAnswerKey, 'paper2.listSubject', []))
    ) {
      if (isEmpty(get(TestAnswerKey, 'paper1.listSubject', []))) {
        setPaperObj({
          key: 'paper2',
          value: 'Paper- 02',
        });
      } else {
        setPaperObj({
          key: 'paper1',
          value: 'Paper- 01',
        });
      }
    }
  };
  const SubjectCardComponent = (props) => (
    <div className="marks">
      <div className="label">
        {isFetching ? <Skeleton width="80%" /> : props.Title}
      </div>
      {isFetching || props.actualScore ? (
        <div className="score">
          {isFetching ? (
            <Skeleton width="80%" />
          ) : (
            `${props.Details}/${props.actualScore}`
          )}
        </div>
      ) : (
        <div className="score">
          {isFetching ? <Skeleton width="80%" /> : props.Details}
        </div>
      )}
    </div>
  );

  return (
    <React.Fragment>
      <div className="list-content flex">
        {(isFetching || !isEmpty(TestAnswerKey)) && (
          <div className="list-header">
            <h3 className="mb-5">
              {isFetching ? (
                <Skeleton width="150px" />
              ) : (
                !isEmpty(TestAnswerKey.paper1) &&
                !isEmpty(TestAnswerKey.paper1.TestName) &&
                TestAnswerKey.paper1.TestName
              )}
            </h3>
            <p className="sub-text">
              {isFetching ? (
                <Skeleton width="100px" />
              ) : (
                !isEmpty(TestAnswerKey.paper1) &&
                !isEmpty(TestAnswerKey.paper1.TestName) &&
                getDateWithDay(TestAnswerKey.paper1.TestDate)
              )}
            </p>
          </div>
        )}
        {(isFetching ||
          !isEmpty(get(TestAnswerKey, 'paper2.listSubject', []))) && (
          <div className="paper-box">
            {isFetching ? (
              <Skeleton width="80px" height="50px" />
            ) : (
              <Button
                variant="outlined"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                {paperObj.value}
                <span className="caret ml-10" />
              </Button>
            )}
          </div>
        )}
      </div>
      <div className="wrapper">
        <div className="marks-wrapper">
          <SubjectCardComponent
            Details={!isFetching && marksScored}
            totalQuestions={!isFetching && totalQuestions}
            items={3}
            Title={!isFetching && 'MARKS SCORED'}
            actualScore={!isFetching && actualScore}
          />
          <SubjectCardComponent
            Details={!isFetching && marksLost}
            totalQuestions={!isFetching && totalQuestions}
            items={3}
            Title={!isFetching && 'NEGATIVE SCORE'}
            actualScore={!isFetching && actualScore}
          />
          <SubjectCardComponent
            Details={!isFetching && marksNotAttempted}
            totalQuestions={!isFetching && totalQuestions}
            items={3}
            Title={!isFetching && 'NOT ATTEMPTED'}
          />
        </div>
        <div className="mt-20">
          {(isFetching ||
            (!isEmpty(TestAnswerKey) && subjectsData.length > 0)) && (
            <SubjectTable subjectsData={subjectsData} isFetching={isFetching} />
          )}
        </div>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={() => handleClose('paper1', 'Paper- 1')}>
            Paper- 1
          </MenuItem>
          <MenuItem onClick={() => handleClose('Paper2', 'Paper- 2')}>
            Paper -2
          </MenuItem>
        </Menu>
      </div>
    </React.Fragment>
  );
}

AnswerKeyAndResponse.propTypes = {
  testID: PropTypes.number,
  Title: PropTypes.string,
  actualScore: PropTypes.number,
  Details: PropTypes.number,
};
